import { isNil } from 'ramda'

import { useFlowQuery } from '@twisto/api-graphql'

export const useGetFlowData = (sessionId: string | null | undefined) => {
  const { data, loading } = useFlowQuery({
    context: { overrideNonFieldErrorHandler: true, overrideGlobalErrors: true },
    variables: {
      auth: {
        sessionId: sessionId ?? '',
      },
    },
    skip: isNil(sessionId),
  })

  return {
    flow: data?.flow,
    loading,
  }
}
